import { BraxSelectOption } from 'design-system';

import { Sector } from './sectors';
import { T } from '../utils/i18n';

export type Activity = 'freelance_architect' | 'freelance_designer' | 'architecture_and_design_office' | 'engineering_office' | 'office_3d' | 'management_projects' | 'decoration' | 'photographic_studio' | 'google_street_view_trusted_agency' | 'freelance_photographer' | 'construction_company' | 'real_state_consulting' | 'freelance_realtor' | 'real_estate_fairs_and_events' | 'real_estate' | 'real_estate_website' | 'real_estate_software' | 'real_estate_inspection' | 'franchise_store' | 'woodwork' | 'furniture' | 'trade_representative' | 'travel_agency' | 'tour_guide' | 'hotel' | 'restaurant' | 'commerce' | 'culture' | 'education' | 'entertainment' | 'government' | 'industry' | 'ads_and_marketing' | 'services' | 'transport';

const activities: (BraxSelectOption<Activity> & { sector: Sector })[] = [{
    value: 'freelance_architect',
    title: <T label="Arquiteto autônomo" />,
    sector: 'architecture_interior_design'
}, {
    value: 'freelance_designer',
    title: <T label="Designer de interiores autônomo" />,
    sector: 'architecture_interior_design'
}, {
    value: 'architecture_and_design_office',
    title: <T label="Escritório de arquitetura ou design" />,
    sector: 'architecture_interior_design'
}, {
    value: 'engineering_office',
    title: <T label="Escritório de engenharia" />,
    sector: 'architecture_interior_design'
}, {
    value: 'office_3d',
    title: <T label="Estúdio 3D | Maquetaria Digital" />,
    sector: 'architecture_interior_design'
}, {
    value: 'management_projects',
    title: <T label="Gestão de obras e projetos" />,
    sector: 'architecture_interior_design'
}, {
    value: 'decoration',
    title: <T label="Revestimentos, acabamentos e decoração" />,
    sector: 'architecture_interior_design'
}, {
    value: 'photographic_studio',
    title: <T label="Agência | Estúdio fotográfico" />,
    sector: 'photography'
}, {
    value: 'google_street_view_trusted_agency',
    title: <T label="Agência Google Street View Trusted" />,
    sector: 'photography'
}, {
    value: 'freelance_photographer',
    title: <T label="Fotógrafo autônomo" />,
    sector: 'photography'
}, {
    value: 'construction_company',
    title: <T label="Construtora e incorporadora" />,
    sector: 'real_estate'
}, {
    value: 'real_state_consulting',
    title: <T label="Consultoria imobiliária" />,
    sector: 'real_estate'
}, {
    value: 'freelance_realtor',
    title: <T label="Corretor de imóveis autônomo" />,
    sector: 'real_estate'
}, {
    value: 'real_estate_fairs_and_events',
    title: <T label="Feiras e eventos imobiliários" />,
    sector: 'real_estate'
}, {
    value: 'management_projects',
    title: <T label="Gestão de obras e projetos" />,
    sector: 'real_estate'
}, {
    value: 'real_estate',
    title: <T label="Imobiliária" />,
    sector: 'real_estate'
}, {
    value: 'real_estate_website',
    title: <T label="Portal ou site imobiliário" />,
    sector: 'real_estate'
}, {
    value: 'real_estate_software',
    title: <T label="Software imobiliário" />,
    sector: 'real_estate'
}, {
    value: 'office_3d',
    title: <T label="Estúdio 3D | Maquetaria Digital" />,
    sector: 'real_estate'
}, {
    value: 'real_estate_inspection',
    title: <T label="Vistoria imobiliária" />,
    sector: 'real_estate'
}, {
    value: 'franchise_store',
    title: <T label="Loja de rede ou franquia" />,
    sector: 'furniture'
}, {
    value: 'woodwork',
    title: <T label="Marcenaria independente" />,
    sector: 'furniture'
}, {
    value: 'furniture',
    title: <T label="Móveis em geral" />,
    sector: 'furniture'
}, {
    value: 'trade_representative',
    title: <T label="Representante comercial" />,
    sector: 'furniture'
}, {
    value: 'travel_agency',
    title: <T label="Agência de viagens" />,
    sector: 'tourism'
}, {
    value: 'tour_guide',
    title: <T label="Guia de turismo" />,
    sector: 'tourism'
}, {
    value: 'hotel',
    title: <T label="Hotel, hostel ou pousada" />,
    sector: 'tourism'
}, {
    value: 'restaurant',
    title: <T label="Restaurante" />,
    sector: 'tourism'
}, {
    value: 'commerce',
    title: <T label="Comércio | Varejo" />,
    sector: 'others'
}, {
    value: 'culture',
    title: <T label="Cultura" />,
    sector: 'others'
}, {
    value: 'education',
    title: <T label="Educação" />,
    sector: 'others'
}, {
    value: 'entertainment',
    title: <T label="Eventos | Entretenimento" />,
    sector: 'others'
}, {
    value: 'government',
    title: <T label="Governo" />,
    sector: 'others'
}, {
    value: 'industry',
    title: <T label="Indústria" />,
    sector: 'others'
}, {
    value: 'ads_and_marketing',
    title: <T label="Publicidade e propaganda" />,
    sector: 'others'
}, {
    value: 'services',
    title: <T label="Serviços" />,
    sector: 'others'
}, {
    value: 'transport',
    title: <T label="Transportes" />,
    sector: 'others'
}];

export default activities;
